import { isNil } from 'ramda';
import ErrorCodes from '../constants/ErrorCodes';
import { TechnicalErrorReportService } from './TechnicalErrorReportService';
class SourceService {
  static createRequest({
    method,
    parse
  }) {
    return ({
      requestURL,
      headers,
      body = null,
      credentials
    }) => {
      return fetch(requestURL, {
        method,
        mode: 'cors',
        headers,
        credentials,
        ...(!isNil(body) && {
          body: JSON.stringify(body)
        })
      }).then(response => {
        if (response.ok) {
          return response.json().then(data => ({
            error: false,
            payload: parse(data)
          })).catch(ex => ({
            error: true,
            payload: {
              requestURL,
              status: ErrorCodes.PARSE_ERROR,
              text: ex.toString()
            }
          }));
        } else {
          return response.json().then(e => {
            const payload = {
              requestURL,
              status: response.status,
              text: e.error ? e.error.message : null,
              type: e.error ? e.error.type : null,
              retryAfter: e.error ? e.error.retry_after : null
            };
            TechnicalErrorReportService.report({
              ...payload,
              method
            });
            return {
              error: true,
              payload
            };
          });
        }
      }).catch(ex => {
        const payload = {
          requestURL,
          status: ErrorCodes.FETCH_ERROR,
          text: ex.toString()
        };
        TechnicalErrorReportService.report({
          ...payload,
          method
        });
        return {
          error: true,
          payload
        };
      });
    };
  }
}
export { SourceService };